import * as t from './reducers';
import { ActionReducerMap, combineReducers, compose } from '@ngrx/store';

export const featureKey = 'user-management-core';

export interface RolesFeatureState {
  rolesState: t.RolesState;
}

export const reducers: ActionReducerMap<RolesFeatureState> = {
  rolesState: t.roleReducer,
};

export function store(state: any, action: any): RolesFeatureState {
  const actionReducer = compose(combineReducers)(reducers);
  return actionReducer(state, action);
}
